<template>
  <div class="modalBase" :style="getBaseStyles">
    <div class="modal-container" :style="getCustomStyles">
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalBase",
  props: {
    baseBackground: String,
    width: {
      type: [Number, String],
      default: 600,
    },
    height: {
      type: [Number, String],
      default: 600,
    },
    boxShadow: {
      type: String,
      default: "",
    },
  },
  computed: {
    getBaseStyles() {
      let styles = "";
      if (this.baseBackground) {
        let baseBackground = `background: ${this.baseBackground};`;
        styles = baseBackground;
      }
      return styles;
    },
    getCustomStyles() {
      let styles = "";
      if (this.height) {
        let height = `height: ${this.height}px;`;
        styles = height;
      }
      if (this.width) {
        let width = `width: ${this.width}px;`;
        styles = styles = " " + width;
      }
      if (this.boxShadow) {
        let boxShadow = `box-shadow: ${this.boxShadow};`;
        styles = styles = " " + boxShadow;
      }
      return styles;
    },
  },
};
</script>

<style>
@import "./styles/ModalBase.css";
</style>